// frontend/src/services/platform.ts
// Thin platform abstraction so the same code runs on web (browser) and native
// (iOS via Capacitor). On web, falls back to localStorage and window.open. On
// native, uses Capacitor Preferences (survives WKWebView storage eviction) and
// the Capacitor Browser plugin (opens an in-app SFSafariViewController instead
// of trapping the user inside the app's WebView).

import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { Browser } from '@capacitor/browser';

export const isNativePlatform = (): boolean => Capacitor.isNativePlatform();

const AUTH_TOKEN_KEY = 'authToken';

export const tokenStorage = {
  async get(): Promise<string | null> {
    if (isNativePlatform()) {
      const { value } = await Preferences.get({ key: AUTH_TOKEN_KEY });
      return value ?? null;
    }
    return localStorage.getItem(AUTH_TOKEN_KEY);
  },
  async set(token: string): Promise<void> {
    if (isNativePlatform()) {
      await Preferences.set({ key: AUTH_TOKEN_KEY, value: token });
      return;
    }
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  },
  async remove(): Promise<void> {
    if (isNativePlatform()) {
      await Preferences.remove({ key: AUTH_TOKEN_KEY });
      return;
    }
    localStorage.removeItem(AUTH_TOKEN_KEY);
  },
};

export async function openExternalUrl(url: string): Promise<void> {
  if (isNativePlatform()) {
    await Browser.open({ url });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}
